import type { GatsbyBrowser } from 'gatsby';

const getAbsoluteOffsetTop = (element: HTMLElement) => {
  let offsetTop = 0;
  while (element) {
    offsetTop += element.offsetTop;
    element = element.offsetParent as HTMLElement;
  }

  return offsetTop;
};

/**
 *
 * @desc - a function to jump to the correct scroll position
 * @param {Object} location -
 * @param {Number} [mainNavHeight] - height of any persistent nav -> document.querySelector(`nav`)
 */
const scrollToAnchor = (location: Location, mainNavHeight = 0) => {
  // Check for location so build does not fail
  if (location && location.hash) {
    if (document.querySelector(`${location.hash}`)) {
      const item = getAbsoluteOffsetTop(document.querySelector(`${location.hash}`) as HTMLElement);

      window.scrollTo({
        top: item - mainNavHeight,
        behavior: 'smooth',
      });
    } else {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }

  return true;
};

export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = ({ routerProps }) => {
  const { location } = routerProps;
  if (location.state) {
    const { disableScrollUpdate } = location.state;

    if (!location?.hash || location.hash === '') {
      return !disableScrollUpdate;
    } else {
      scrollToAnchor(location, 0);

      return false;
    }
  }

  return false;
};
